import * as React from 'react';
import * as style from './CompilationHeaderLayout.css';

export interface ICompilationHeaderLayoutProps {
  title: React.ReactNode;
  description: React.ReactNode;
}

export const CompilationHeaderLayout = React.forwardRef<HTMLDivElement, ICompilationHeaderLayoutProps>(
  ({ title, description }, ref) => {
    return (
      <div className={style['container']} ref={ref}>
        {title}
        {description}
      </div>
    );
  },
);

CompilationHeaderLayout.displayName = 'CompilationHeaderLayout';
